import { useTranslation } from "react-i18next";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "~/components/ui";

interface EvidenceActivationDialogProps {
  open: boolean;
  onOpenChange: (next: boolean) => void;
  /** When true the action will deactivate; otherwise activate. */
  deactivate: boolean;
  processing: boolean;
  onConfirm: () => void;
}

export function EvidenceActivationDialog({
  open,
  onOpenChange,
  deactivate,
  processing,
  onConfirm,
}: EvidenceActivationDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="capitalize">
            {deactivate ? t("ui.deactivate") : t("ui.activate")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {deactivate
              ? t("feature.evidences.detail.confirmDeactivate")
              : t("feature.evidences.detail.confirmActivate")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={processing}>{t("ui.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={processing}>
            {t("ui.ok")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
